import React from 'react'

import { shallowEqual, useSelector } from 'react-redux'

import { SubmissionChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectSubmissionChannel } from '@store/postCampaignReport'
import { Icon } from '@tribegroup'

interface IProps {
  submissionId: number
}

const AnalyticsPostCampaignReportListViewProfileSocialIcon = ({ submissionId }: IProps) => {
  const { channel } = useSelector((state: IApplicationState) => {
    return {
      channel: selectSubmissionChannel(state, submissionId),
    }
  }, shallowEqual)

  switch (channel) {
    case SubmissionChannels.TikTok: {
      return <Icon size={0.75} glyph={`social-tiktok-colour`} />
    }

    case SubmissionChannels.X: {
      return <Icon size={0.75} glyph={`social-x`} />
    }

    case SubmissionChannels.Snapchat: {
      return <Icon size={0.75} glyph={`social-snapchat-colour`} />
    }

    case SubmissionChannels.YouTube: {
      return <Icon size={0.75} glyph={`social-youtube-colour`} />
    }

    default: {
      return <Icon size={0.75} glyph={`social-instagram-colour`} />
    }
  }
}

export default AnalyticsPostCampaignReportListViewProfileSocialIcon
